import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import env from './env';

export const datadogLogsHandler = (error, errorInfo) => {
  datadogLogs.logger.error(`Error: ${error}`, `Error info: ${errorInfo}`);
};

export const initializeDatadogRum = () => {
  datadogRum.init({
    applicationId: env.datadogRumAppId,
    clientToken: env.datadogRumClientToken,
    site: 'datadoghq.com',
    service: 'pandora',
    env: env.appEnv,
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sampleRate: 100,
    sessionReplaySampleRate: 20,
    trackInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
};

export const initializeDatadogLogs = () => {
  datadogLogs.init({
    clientToken: env.datadogLogsId,
    env: env.appEnv,
    service: 'pandora',
  });
};
